const filter = () => {
	document.addEventListener('DOMContentLoaded', function () {
		/* Drop down */
		const btnFilter = document.querySelector('.flex-filter')
		const dropdown = document.querySelector('.article-blog__dropdown')
		if(btnFilter && dropdown){
			document.addEventListener('click', function(e){
				if(btnFilter.contains(e.target)){
					dropdown.classList.toggle('drop-down')		
				}else{
					dropdown.classList.remove('drop-down')		
				}
			})
		}

		/* Class active on click */
		const classActive = document.querySelectorAll('.js-filter-item')
		classActive.forEach(function(el){
			el.addEventListener('click', function(){
				for(let i = 0; i<classActive.length; i++){
					classActive[i].classList.remove('activeClass')
				}
				el.classList.add('activeClass')
			})
		})
	})
}

export default filter
